export const GET_TREATMENT_PAGE_START = 'GET_TREATMENT_PAGE_START';
export const GET_TREATMENT_PAGE_SUCCESS = 'GET_TREATMENT_PAGE_SUCCESS';
export const GET_TREATMENT_PAGE_ERROR = 'GET_TREATMENT_PAGE_ERROR';
export const TOGGLE_CHECKBOX_START = 'TOGGLE_CHECKBOX_START';
export const TOGGLE_CHECKBOX_SUCCESS = 'TOGGLE_CHECKBOX_SUCCESS';
export const TOGGLE_CHECKBOX_ERROR = 'TOGGLE_CHECKBOX_ERROR';
export const CLEAR_TOGGLE_CHECKBOX_ERROR = 'CLEAR_TOGGLE_CHECKBOX_ERROR';
export const DOWNLOAD_TREATMENT_PRESCRIPTION_START =
  'DOWNLOAD_TREATMENT_PRESCRIPTION_START';
export const DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS =
  'DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS';
export const DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR =
  'DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR';
export const DOWNLOAD_TREATMENT_PRESCRIPTION_CLEAR =
  'DOWNLOAD_TREATMENT_PRESCRIPTION_CLEAR';
export const DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START =
  'DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START';
export const DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS =
  'DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS';
export const DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR =
  'DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR';
export const CLEAR_DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN =
  'CLEAR_DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN';

// Is silent is used to prevent the loading state from being set when the action is called
export const getTreatmentPage = (treatmentId, language, isSilent = false) => ({
  type: GET_TREATMENT_PAGE_START,
  payload: {
    treatmentId,
    language,
    isSilent,
  },
});

export const toggleCheckbox = (
  stepId,
  dayNumber,
  treatmentId,
  language = 'en',
) => ({
  type: TOGGLE_CHECKBOX_START,
  payload: {
    stepId,
    dayNumber,
    treatmentId,
    language,
  },
});

export const clearToggleCheckboxError = () => ({
  type: CLEAR_TOGGLE_CHECKBOX_ERROR,
});

export const downloadTreatmentPrescription = (
  documentId,
  treatmentId,
  stepId,
) => ({
  type: DOWNLOAD_TREATMENT_PRESCRIPTION_START,
  payload: {
    documentId,
    treatmentId,
    stepId,
  },
});

export const clearDownloadTreatmentPrescription = () => ({
  type: DOWNLOAD_TREATMENT_PRESCRIPTION_CLEAR,
});

export const downloadNutritionAdviceActionPlan = (
  treatmentId,
  stepId,
  buttonType,
) => ({
  type: DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START,
  payload: {
    treatmentId,
    stepId,
    buttonType,
  },
});

export const clearDownloadNutritionAdviceActionPlan = () => ({
  type: CLEAR_DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN,
});
